import React, { useState } from "react";
import {
  StepContainer,
  BoxTitle,
  BlackHighlight,
} from "../createWorkflowViewer.styles";
import { ReactFlow, ReactFlowProvider } from "reactflow";
import { nodes, edges } from "./workflowNodeEdges";
import { Node, ConfigureNode } from "./node";
import { CreateAwaInputDataSidebar, AwaData } from "../createWorkflowSidebars";

export const WorkflowConfiguration: React.FC<{
  awaData: AwaData;
  onSubmit: (awaData: AwaData) => void;
}> = ({ awaData, onSubmit }) => {
  const [showAwaSideBar, setShowAwaSideBar] = useState(false);

  const onNodeClick = (_, node) => {
    if (node.data.isConfigurable) {
      setShowAwaSideBar(true);
    }
  };
  return (
    <StepContainer height={"1250px"}>
      <CreateAwaInputDataSidebar
        isOpen={showAwaSideBar}
        initAwaData={awaData}
        onClose={() => setShowAwaSideBar(false)}
        onSubmit={(data) => {
          setShowAwaSideBar(false);
          onSubmit(data);
        }}
      />
      <BoxTitle withPadding>
        <BlackHighlight>Step 2:</BlackHighlight> Workflow Configuration
      </BoxTitle>
      <div
        className="nowheel"
        style={{
          position: "relative",
          backgroundColor: "#F1F8FB",
          height: "100%",
          marginTop: "1rem",
        }}
      >
        <ReactFlowProvider>
          <ReactFlow
            zoomOnDoubleClick={false}
            zoomOnScroll={false}
            nodes={nodes}
            edges={edges}
            nodeTypes={{ node: Node, configureNode: ConfigureNode } as any}
            onNodeClick={onNodeClick}
            fitView
            fitViewOptions={{
              duration: 800,
            }}
          ></ReactFlow>
        </ReactFlowProvider>
      </div>
    </StepContainer>
  );
};
